<template>
    <div class="pb-0">
        <div class="col-12 px-0">
            <announcement-view></announcement-view>
        </div>
        <div class="row">
            <div class="col-md-6 mb-1 mb-md-0">
                <v-stats-box text="Günlük Tahsilat" variant="warning" icon="currency_lira" :value="date || '0,00'"></v-stats-box>
            </div>
            <div class="col-md-6">
                <v-stats-box text="Aylık Tahsilat" variant="danger" icon="currency_lira" :value="month || '0,00'"></v-stats-box>
            </div>
        </div>
        <b-overlay :show="rupsLoading" opacity="0.2" v-if="isResponsible">
            <b-card class="mt-1 mb-0" body-class="p-75">
                <h2 class="p-25 font-weight-bolder">Sorumlu Olunan Günlük İşlem Hareketleri</h2>
                <vue-perfect-scrollbar class="card-wrapper">
                    <table class="table table-bordered table-sm mb-1">
                        <thead>
                            <tr>
                                <th>İşlemler</th>
                                <th class="text-nowrap w-10">Cari Kod</th>
                                <th class="text-nowrap w-10">İşlem Zamanı</th>
                                <th class="text-nowrap w-10">Talep Eden Kullanıcı</th>
                                <th class="text-nowrap w-10">Son Yanıtlama Tarihi</th>
                                <th class="text-nowrap w-10">Yanıt Tarihi</th>
                                <th class="text-nowrap w-10">Ortalama Gün</th>
                                <th class="text-nowrap w-20">Durum</th>
                                <th class="text-nowrap w-10">Tutar (TL)</th>
                                <th class="text-nowrap w-10">Son Ödeme Tarihi</th>
                                <th class="text-nowrap w-10">Ödeme Tarihi</th>
                                <th class="text-nowrap w-10">Açıklama</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="ps in responsibleUserPaymentStatuses">
                                <tr :key="ps.Id">
                                    <td>
                                        <button class="btn btn-primary btn-sm d-flex align-items-center" v-if="ps.Status == 0" v-on:click="approve(ps)">
                                            <b-spinner small class="mr-50" v-if="approving && cid == ps.Id"></b-spinner>
                                            Onayla
                                        </button>
                                    </td>
                                    <td class="text-nowrap">{{ $safe(ps, "CariCode") || "-" }}</td>
                                    <td class="text-nowrap">{{ $safe(ps, "DateStr") || "-" }}</td>
                                    <td class="text-nowrap">{{ $safe(ps, "RequesterUserName") || "-" }}</td>
                                    <td class="text-nowrap">{{ $safe(ps, "ResponsibleUserLastApproveDate") || "-" }}</td>
                                    <td class="text-nowrap">{{ $safe(ps, "ResponsibleUserApproveDate") || "-" }}</td>
                                    <td class="text-nowrap">{{ $safe(ps, "AverageDate") || "-" }}</td>
                                    <td class="text-nowrap font-weight-bolder">{{ $safe(ps, "StatusStr") || "-" }}</td>
                                    <td class="text-nowrap">{{ $safe(ps, "TotalAmount") || "-" }}</td>
                                    <td class="text-nowrap">{{ $safe(ps, "InvoiceLastPaymentDate") || "-" }}</td>
                                    <td class="text-nowrap">{{ $safe(ps, "InvoicePaymentDate") || "-" }}</td>
                                    <td class="text-nowrap">{{ $safe(ps, "Description") || "-" }}</td>
                                </tr>
                                <tr :key="ps.Id + '-dl'" v-if="ps.DocumentList">
                                    <td colspan="20">
                                        <div class="table-responsive mb-0">
                                            <table class="table table-bordered table-sm">
                                                <thead>
                                                    <th class="text-nowrap w-34">Fatura Numarası</th>
                                                    <th class="text-nowrap w-33">Fatura Kesim Tarihi</th>
                                                    <th class="text-nowrap w-33">Borç</th>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="dl in ps.DocumentList" :key="dl.DocumentNo">
                                                        <td>{{ $safe(dl, "DocumentNo") || "-" }}</td>
                                                        <td>{{ $safe(dl, "Date") || "-" }}</td>
                                                        <td>{{ $safe(dl, "Debt") || "-" }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                            <tr v-if="responsibleUserPaymentStatuses.length == 0">
                                <td colspan="20" class="text-center">Henüz bir veri bulunmamaktadır.</td>
                            </tr>
                        </tbody>
                    </table>
                </vue-perfect-scrollbar>
            </b-card>
        </b-overlay>

        <b-overlay :show="psLoading" opacity="0.2">
            <b-card class="mt-1 mb-0 mb-lg-0" body-class="p-75">
                <h2 class="p-25 font-weight-bolder">Günlük İşlem Hareketleri</h2>
                <vue-perfect-scrollbar class="card-wrapper">
                    <table class="table table-bordered table-sm mb-1">
                        <thead>
                            <tr>
                                <th>İşlemler</th>
                                <th class="text-nowrap w-5">Grup Kodu</th>
                                <th class="text-nowrap w-5">Cari Kod</th>
                                <th class="text-nowrap w-10">Cari Adı</th>
                                <th class="text-nowrap w-10">İşlem Zamanı</th>
                                <th class="text-nowrap w-10">Sor. Kul.</th>
                                <th class="text-nowrap w-10">Sor. Kul. Son Yanıt Tarihi</th>
                                <th class="text-nowrap w-10">Sor. Kul. Yanıt Tarihi</th>
                                <th class="text-nowrap w-10">Ortalama Gün</th>
                                <th class="text-nowrap w-10">Açıklama</th>
                                <th class="text-nowrap w-10">Son Ödeme Tarihi</th>
                                <th class="text-nowrap w-10">Ödeme Tarihi</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="ps in paymentStatuses">
                                <tr :key="ps.Id">
                                    <td>
                                        <button class="btn btn-primary btn-sm d-flex align-items-center" v-if="ps.Status == 2" v-on:click="approveRequestAgain(ps)">
                                            <b-spinner small class="mr-50" v-if="pending && cid == ps.Id"></b-spinner>
                                            Onaya gönder
                                        </button>
                                    </td>
                                    <td class="text-nowrap">
                                        <a :href="'/Payment/' + ps.InvoiceGroupCode" target="_blank">{{ $safe(ps, "InvoiceGroupCode") || "-" }}</a>
                                    </td>
                                    <td class="text-nowrap">{{ $safe(ps, "CariCode") || "-" }}</td>
                                    <td class="text-nowrap">{{ $safe(ps, "CariName") || "-" }}</td>
                                    <td class="text-nowrap">{{ $safe(ps, "DateStr") || "-" }}</td>
                                    <td class="text-nowrap">{{ $safe(ps, "ResponsibleUserName") || "-" }}</td>
                                    <td class="text-nowrap">{{ $safe(ps, "ResponsibleUserLastApproveDate") || "-" }}</td>
                                    <td class="text-nowrap">{{ $safe(ps, "ResponsibleUserApproveDate") || "-" }}</td>
                                    <td class="text-nowrap">{{ $safe(ps, "AverageDate") || "-" }}</td>
                                    <td class="text-nowrap">{{ $safe(ps, "Description") || "-" }}</td>
                                    <td class="text-nowrap">{{ $safe(ps, "InvoiceLastPaymentDate") || "-" }}</td>
                                    <td class="text-nowrap">{{ $safe(ps, "InvoicePaymentDate") || "-" }}</td>
                                </tr>
                                <tr :key="ps.Id + '-dl'" v-if="ps.DocumentList">
                                    <td colspan="20">
                                        <div class="table-responsive mb-0">
                                            <table class="table table-bordered table-sm">
                                                <thead>
                                                    <th class="text-nowrap w-20">Durum</th>
                                                    <th class="text-nowrap w-20">Fatura Numarası</th>
                                                    <th class="text-nowrap w-20">Fatura Kesim Tarihi</th>
                                                    <th class="text-nowrap w-10">Borç</th>
                                                    <th class="text-nowrap w-10">Ödenen Tutar</th>
                                                    <th class="text-nowrap w-10">Kalan Tutar</th>
                                                    <th class="text-nowrap w-10">Fazla Ödenen Tutar</th>
                                                </thead>
                                                <tbody>
                                                    <tr :class="setPaymentStatusColor(dl.Status)" v-for="dl in ps.DocumentList" :key="dl.DocumentNo">
                                                        <td class="text-nowrap font-weight-bolder">{{ $safe(dl, "StatusStr") || "-" }}</td>
                                                        <td>{{ $safe(dl, "DocumentNo") || "-" }}</td>
                                                        <td>{{ $safe(dl, "Date") || "-" }}</td>
                                                        <td>{{ $safe(dl, "Debt") || "-" }}</td>
                                                        <td>{{ $safe(dl, "PaidPart") || "-" }}</td>
                                                        <td>{{ $safe(dl, "RemainingDebt") || "-" }}</td>
                                                        <td>{{ $safe(dl, "OverPaymentPart") || "-" }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                            <tr v-if="paymentStatuses.length == 0">
                                <td colspan="20" class="text-center">Henüz bir veri bulunmamaktadır.</td>
                            </tr>
                        </tbody>
                    </table>
                </vue-perfect-scrollbar>
            </b-card>
        </b-overlay>
    </div>
</template>

<script>
import { BCard, BCardText, BLink, BImg, BOverlay, BSpinner } from "bootstrap-vue";
//import Notifications from '@/utilities/notifications'
import { PaymentApi } from "@/api/payment";
import VStatsBox from "@/components/VStatsBox.vue";
import AnnouncementView from "./announcement/AnnouncementView.vue";
import Auth from "@/utilities/auth";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
export default {
    components: {
        BCard,
        BCardText,
        BLink,
        BImg,
        VStatsBox,
        VuePerfectScrollbar,
        BOverlay,
        BSpinner,
        AnnouncementView,
    },
    data() {
        return {
            date: null,
            month: null,
            paymentStatuses: [],
            responsibleUserPaymentStatuses: [],
            psLoading: false,
            rupsLoading: false,
            approving: false,
            cid: null,
            pending: false,
        };
    },
    mounted() {
        //Notifications.getNotifications()
        this.getCurrentDate();
        this.getCurrentMonth();
        this.getPaymentStatuses();
        if (this.isResponsible) {
            this.getResponisbleUserPaymentStatuses();
        }
    },
    methods: {
        setPaymentStatusColor(paymentStatus) {
            if (paymentStatus == 6 || paymentStatus == 7) return "bg-light-success";
            if (paymentStatus == 5) return "bg-light-primary";
            if (paymentStatus == 4 || paymentStatus == 2) return "bg-light-danger";
            if (paymentStatus == 0) return "bg-light-info";
            if (paymentStatus == 3) return "bg-light-warning";
            return "";
        },
        getCurrentDate() {
            PaymentApi.CurrentDateTotalAmount().then((res) => {
                this.date = res.data.Message;
            });
        },
        getCurrentMonth() {
            PaymentApi.CurrentMonthTotalAmount().then((res) => {
                this.month = res.data.Message;
            });
        },
        getPaymentStatuses() {
            this.psLoading = true;
            PaymentApi.SalesmanPaymentStatusList()
                .then((res) => {
                    this.psLoading = false;
                    this.paymentStatuses = res.data.Data;
                })
                .catch(() => (this.psLoading = false));
        },
        getResponisbleUserPaymentStatuses() {
            this.rupsLoading = true;
            PaymentApi.ResponsibleUserPaymentStatusList()
                .then((res) => {
                    this.responsibleUserPaymentStatuses = res.data.Data;
                    this.rupsLoading = false;
                })
                .catch(() => (this.rupsLoading = false));
        },
        approve(ps) {
            this.cid = ps.Id;
            this.approving = true;
            PaymentApi.ApproveInstallment(ps.InvoiceGroupCode)
                .then((res) => {
                    this.$result(res);
                    this.approving = false;
                    if (res.data.Success) {
                        this.getResponisbleUserPaymentStatuses();
                    }
                })
                .catch((err) => {
                    this.$result(null, err);
                    this.approving = false;
                });
        },
        approveRequestAgain(ps) {
            this.cid = ps.Id;
            this.pending = true;
            PaymentApi.ApproveRequestAgain(ps.InvoiceGroupCode)
                .then((res) => {
                    this.$result(res);
                    this.pending = false;
                    if (res.data.Success) {
                        this.getPaymentStatuses();
                    }
                })
                .catch((err) => {
                    this.$result(null, err);
                    this.pending = false;
                });
        },
    },
    computed: {
        isResponsible() {
            return Auth.isResponsible;
        },
    },
};
</script>

<style>
.card-wrapper {
    max-height: calc(100vh - 19rem);
}

@media screen and (max-width: 767px) {
    .card-wrapper {
        max-height: calc(100vh - 26rem);
    }
}
</style>
